/**
 * Footer Mobile Accordion Functionality
 * 功能描述：为移动端footer菜单添加手风琴展开/收起功能
 * 作者：AI Assistant
 * 创建时间：2024-12-19
 */

class FooterMobileAccordion {
  constructor() {
    this.init();
  }

  init() {
    // 只在移动端且非横屏时初始化
    if (this.shouldInitialize()) {
      this.setupAccordion();
    }
    
    // 监听屏幕方向变化
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        if (this.shouldInitialize()) {
          this.setupAccordion();
        } else {
          this.removeAccordion();
        }
      }, 100);
    });

    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      if (this.shouldInitialize()) {
        this.setupAccordion();
      } else {
        this.removeAccordion();
      }
    });
  }

  shouldInitialize() {
    // 只在移动端（宽度小于750px）且竖屏时初始化
    return window.innerWidth < 750 && window.innerHeight > window.innerWidth;
  }

  setupAccordion() {
    const accordionHeadings = document.querySelectorAll('.footer-block__heading--mobile-accordion');
    
    accordionHeadings.forEach(heading => {
      // 如果已经绑定了事件，跳过
      if (heading.dataset.accordionInitialized) {
        return;
      }

      const menuContent = heading.nextElementSibling;
      if (!menuContent || !menuContent.classList.contains('footer-block__menu-content')) {
        return;
      }

      // 标记为已初始化
      heading.dataset.accordionInitialized = 'true';

      const container = heading.closest('[data-mobile-default]');
      const defaultState = container?.dataset.mobileDefault || 'expanded';
      const isCollapsed = defaultState === 'collapsed';

      if (isCollapsed) {
        heading.classList.add('collapsed');
        menuContent.classList.add('collapsed');
        menuContent.style.maxHeight = '0px';
      } else {
        heading.classList.remove('collapsed');
        menuContent.classList.remove('collapsed');
        menuContent.style.maxHeight = menuContent.scrollHeight + 'px';
      }

      // 绑定点击事件
      heading.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(heading, menuContent);
      });
    });
  }

  toggleAccordion(heading, menuContent) {
    const isCollapsed = heading.classList.contains('collapsed');
    
    if (isCollapsed) {
      // 展开
      heading.classList.remove('collapsed');
      menuContent.classList.remove('collapsed');
      menuContent.style.maxHeight = menuContent.scrollHeight + 'px';
    } else {
      // 收起
      heading.classList.add('collapsed');
      menuContent.classList.add('collapsed');
      menuContent.style.maxHeight = '0px';
    }
  }

  removeAccordion() {
    const accordionHeadings = document.querySelectorAll('.footer-block__heading--mobile-accordion');
    
    accordionHeadings.forEach(heading => {
      // 移除事件监听器
      heading.removeEventListener('click', this.toggleAccordion);
      
      // 重置状态
      heading.classList.remove('collapsed');
      const menuContent = heading.nextElementSibling;
      if (menuContent && menuContent.classList.contains('footer-block__menu-content')) {
        menuContent.classList.remove('collapsed');
        menuContent.style.maxHeight = '';
      }
      
      // 移除初始化标记
      delete heading.dataset.accordionInitialized;
    });
  }
}

// 当DOM加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  new FooterMobileAccordion();
});

// 如果DOM已经加载完成，立即初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FooterMobileAccordion();
  });
} else {
  new FooterMobileAccordion();
}
